var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"tech-ambient-glow tech-glow-top"}),_c('div',{staticClass:"tech-ambient-mesh"}),_c('div',{staticClass:"app-main-content"},[_c('router-view')],1),_c('div',{staticClass:"tech-ambient-glow tech-glow-bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }